<template>
  <div class="div" v-loading="loading" style="padding: 0">
    <div class="div-top" style="margin-top: 10px">
      <!-- <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新建</el-button>
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      > -->
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入备件名称"
        style="width: 300px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出初始化模板</el-button
      >
      <Upload
        :text="'导入初始化数据'"
        style="margin-left: 10px"
        ref="Upload"
        :uploadUrl="
          $rootUrl +
          '/Base_DeviceTreeManage/Accessory_Material/ImportAccessory_MaterialToDataBase'
        "
        @success="handleSearch"
      ></Upload>
      <el-button
        type="success"
        @click="openDom"
        style="margin-left: 10px"
        icon="el-icon-right"
        >入库</el-button
      >
      <!-- <el-button type="primary" @click="handleAdd" style="margin-left: 10px"
      icon="el-icon-upload2"
        >导入初始化数据</el-button
      > -->
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <!-- <el-table-column label="" width="50" type="selection"> </el-table-column> -->
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column
          label="备件编号"
          align="center"
          prop="AccessoryCode"
          sortable
        >
        </el-table-column>
        <el-table-column label="备件名称" align="center" prop="Name" sortable>
        </el-table-column>
        <el-table-column
          label="备件类型"
          align="center"
          prop="MaterialType"
          sortable
        >
        </el-table-column>
        <el-table-column label="备件规格" align="center" prop="Spec" sortable>
        </el-table-column>
        <el-table-column label="厂家" align="center" prop="Supplier" sortable>
        </el-table-column>
        <el-table-column label="计量单位" align="center" prop="Unit" sortable>
        </el-table-column>
        <el-table-column label="数量" align="center" prop="Nums" sortable>
        </el-table-column>

        <el-table-column
          label="移交编号"
          align="center"
          prop="MaterialCode"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="移交名称"
          align="center"
          prop="MaterialName"
          sortable
        >
        </el-table-column>
        <el-table-column label="入库状态" align="center" prop="Status" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Status === 0">未入库</el-tag>
            <el-tag v-else-if="scope.row.Status === 1" type="success"
              >已入库</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.Status === 0"
              disabled
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="请选择入库货位"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <SekectShelf
        ref="SekectShelf"
        v-model="Shelf.LocalId"
        @select="selectShelf"
      ></SekectShelf>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AutomaticStorage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tools from '@/utils/tools.js'
import Token from '@/utils/cache/TokenCache.js'
import SekectShelf from '@/components/SekectShelf/SekectShelf.vue'
import Upload from '@/components/Upload/Upload.vue'
import { Loading } from 'element-ui'

export default {
  data() {
    return {
      Shelf: {
        LocalId: '',
        AreaId: '',
        RackId: '',
      },
      token: 'Bearer ' + Token.getToken(),
      searchData: {
        Condition: 'Name',
        Keyword: '',
      },
      dialogVisible: false,

      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { Upload, SekectShelf },
  methods: {
    AutomaticStorage() {
      if (!this.Shelf.LocalId) {
        return this.$notify.error('请选择入库货位')
      }
      const loadingInstance = Loading.service({
        fullscreen: true,
        text: '正在入库中...',
      })
      this.$http
        .post('/TD/TD_InStorage/AutomaticStorage', {
          ...this.Shelf,
        })
        .then((res) => {
          loadingInstance.close()
          if (res.Success) {
            this.dialogVisible = false
            this.$notify.success('入库成功')
            this.getDataList()
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    selectShelf(obj) {
      this.$set(this.Shelf, 'AreaId', obj.PB_StorArea.Id)
      this.$set(this.Shelf, 'RackId', obj.PB_Rack.Id)
    },
    openDom() {
      this.Shelf = {
        LocalId: '',
        AreaId: '',
        RackId: '',
      }
      this.dialogVisible = true
    },
    handleExport() {
      tools.download(
        this.$rootUrl + '/Base/Base_Device/ExportAccessoryToExcel',
        '备件对应表',
        '.xlsx',
        'get'
      )
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Accessory_Material/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建用户')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该备件备件, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Accessory_Material/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑用户', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
div {
  padding: 0;
}
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 40px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
